// extracted by mini-css-extract-plugin
export default {"mainContainer":"Ariba_mainContainer__biYwC","blob":"Ariba_blob__OZMUB","glassCard":"Ariba_glassCard__KWPdT","titleGradient":"Ariba_titleGradient__e8DQt"};